import useFlag from 'lane-shared/hooks/useFlag';
import { FeatureFlag } from 'constants-flags';

/**
 * Generated with generate-feature-flag-custom-hook.sh script
 * on 2026-09-01T08:54:13-0700.
 */
export function useSrChargeVerificationEnabled() {
  const isEnabled = useFlag<boolean>(
    FeatureFlag.SrChargeVerification,
    false
  );

  return Boolean(isEnabled);
}
